import React from 'react';
import {
  components as DefaultSelectComponents,
  SingleValueProps,
} from 'react-select';
import _get from 'lodash/get';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import styles from '../Select.module.scss';

export default function RequiredToReadSingleValue({
  ...props
}: SingleValueProps) {
  const value = _get(props, 'selectProps.value.value', false) as boolean;
  const leftIcon = _get(
    props,
    'selectProps.value.leftIcon',
    'import_contacts',
  ) as string;
  return (
    <DefaultSelectComponents.SingleValue {...props}>
      <div className={styles.requiredToReadSingleValueContent}>
        <span className={styles.requiredToReadIconWrapper}>
          <MaterialIcon icon={leftIcon} symbolsOutlined />
          {value && (
            <span className={styles.requiredToReadBadge}>
              <MaterialIcon icon="emergency" size="md-12" />
            </span>
          )}
        </span>
      </div>
    </DefaultSelectComponents.SingleValue>
  );
}
